import { Button } from "@kirvanobr/button";
import { Check } from "@untitled-ui/icons-react";
import { Logo } from "@kirvanobr/logo";
import { EditorContent } from "@tiptap/react";

import { useCertificateStore } from "@/stores";
import Image from "next/image";
import { styles } from "./CertificateEditor.styles";
import { CertificateEditorContentProps } from "./CertificateEditor.types";
import { CertificateEditorTheme } from "./CertificateEditorTheme";
import { CertificateSvgLandscape } from "./CertificateSvgLandscape";
import { CertificateSvgPortrait } from "./CertificateSvgPortrait";
import { useCertificateEditor } from "./hooks/useCertificateEditor";

export const CertificateEditorContent = ({ editor, fontFamilyOptions }: CertificateEditorContentProps) => {
  const { activeLogo, activeSignature, logo, signature, signatureFontName, orientation, isEditing } =
    useCertificateStore();
  const { handleCancelEditing, onSave } = useCertificateEditor();

  return (
    <div className={styles().base({ orientation })}>
      <div className={styles().editor({ orientation })}>
        {!isEditing && (
          <div className="absolute inset-0 p-6">
            <div className={styles().editorContent()}>
              <div>
                <div
                  className={`${styles().contentCertificateLogo()} ${
                    orientation == "Landscape" ? "mb-10" : "mb-[90px]"
                  }`}
                >
                  {activeLogo && logo && (
                    <Image
                      id="certificate-logo"
                      className={styles().certificateLogo()}
                      src={logo}
                      width={180}
                      height={48}
                      alt="Logo"
                    />
                  )}
                </div>
                <EditorContent editor={editor} />
              </div>
              <div className="flex">
                {activeSignature && signature && (
                  <div className="inline-block text-center">
                    <div className={styles().signature()} style={{ fontFamily: signatureFontName }}>
                      {signature}
                    </div>
                    <div
                      className={styles().signatureText()}
                      style={{ fontFamily: fontFamilyOptions?.find(item => item.active)?.name }}
                    >
                      <strong className="mx-2 block mt-3">{signature}</strong>
                      <span>Produtor</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <Logo variant="full" className={styles().logo()} />
          </div>
        )}
        {isEditing && <CertificateEditorTheme orientation={orientation} />}
        {orientation === "Landscape" ? <CertificateSvgLandscape /> : <CertificateSvgPortrait />}
      </div>

      {isEditing && (
        <div className="flex justify-end mt-8 gap-2">
          <Button variant="auxiliary" onClick={handleCancelEditing}>
            Cancelar
          </Button>
          <Button startContent={<Check />} color="success" onClick={onSave}>
            Salvar
          </Button>
        </div>
      )}
    </div>
  );
};
